import FTLSmartTableStore from "../../../FTLSmartTableDomain/stores/FTLSmartTableStore";
import FTLCredentialListIdCell from "../../../../app/pages/FTLCredentials/FTLCredentialListPage/components/FTLCredentialListIdCell";
import FTLCredentialListUserNameCell from "../../../../app/pages/FTLCredentials/FTLCredentialListPage/components/FTLCredentialListUserNameCell";
import FTLCredentialListCreatedAtCell from "../../../../app/pages/FTLCredentials/FTLCredentialListPage/components/FTLCredentialListCreatedAtCell";
import CredentialListApiRepository from "../../../../infrastructure/api/credentials/CredentialListApiRepository";
const FTLCredentialListStore = FTLSmartTableStore({
    metadata: [{
            id: "id",
            headerName: "id",
            renderCell: FTLCredentialListIdCell
        }, {
            id: "username",
            headerName: "username",
            renderCell: FTLCredentialListUserNameCell
        }, {
            id: "createdAt",
            headerName: "Created At",
            renderCell: FTLCredentialListCreatedAtCell
        }],
    repo: CredentialListApiRepository
});
export default FTLCredentialListStore;
//# sourceMappingURL=FTLCredentialListStore.js.map